/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Arbeitgeberzuschussid2Inputs */



/**

* @param {_Field_Arbeitgeberzuschussid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_arbeitgeberzuschussid2 = /** @type {((inputs?: _Field_Arbeitgeberzuschussid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Arbeitgeberzuschussid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Arbeitgeberzuschuss")
});
export { _field_arbeitgeberzuschussid2 as "_field_arbeitgeberzuschussID" }